import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isAuth = this.authService.getIsAuth();

    if (!isAuth) {
      // /#/login?access_token=... keeps the token in the hash, so window.location.search is empty.
      // /?access_token=... keeps it in the search. Both continue on /login, which reads the query.
      const tokenQuery = this.accessTokenQuery();
      if (tokenQuery) {
        window.location.href = '/login' + tokenQuery;
        return isAuth;
      }

      this.router.navigate(['/login']);
    }
    return isAuth;
  }

  /** "?access_token=...&dep=..." from the query string, or from a legacy #/login?... link. */
  private accessTokenQuery(): string | null {
    const search = window.location.search;
    if (search.indexOf('access_token') > 0) {
      return search;
    }

    const hash = window.location.hash || '';
    const queryIndex = hash.indexOf('?');
    if (queryIndex >= 0 && hash.indexOf('access_token') > queryIndex) {
      return hash.substring(queryIndex);
    }

    return null;
  }
}
